import { EmojiProvider, Emoji } from "react-apple-emojis"
import emojiData from "react-apple-emojis/src/data.json"
import { useEffect, useState } from "react";
import { PERSONALINFO } from "../../util/constants/personalInfo";
import { BP } from "../../util/constants/breakpoints";

export default function FooterCTA() {

    const mobileEmojiWidth = 22;
    const desktopEmojiWidth = 58;

    const [emojiWidth, setEmojiWidth] = useState(mobileEmojiWidth);

    const onWindowWidthChange = () => {
        setEmojiWidth(getEmojiWidth())
    }

    const getEmojiWidth = () => {
        if(window.innerWidth < BP.sm) return mobileEmojiWidth
        else return desktopEmojiWidth
    }

    useEffect(() => {
        setEmojiWidth(getEmojiWidth)
        window.addEventListener("resize", onWindowWidthChange)
        return () => window.removeEventListener("resize", onWindowWidthChange)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    return (
        <>
            <div
                className="
                    h-screen
                    bg-body-bg-light
                    dark:bg-body-bg-dark
                    flex
                    flex-col
                    justify-center
                    items-center
                    text-body-text-light
                    dark:text-body-text-dark
                "
            >
                <h3
                    className="
                        flex
                        items-center
                        justify-center
                        text-xl
                        sm:text-4xl
                        md:text-5xl
                        font-bold
                        tracking-wider
                    "
                >
                    Let's work together! &nbsp;
                    <EmojiProvider data={emojiData}>
                        <Emoji className="inline" name="flexed-biceps" width={emojiWidth}/>
                    </EmojiProvider>
                </h3>
                <div
                    className="
                        flex
                        flex-col
                        items-center
                        md:hidden
                    "
                >
                    <a 
                        className="
                            text-base
                            sm:text-2xl
                            font-normal
                            tracking-widest
                            mt-1

                            hover:text-footerCTA-text-primary
                            transition-colors 
                            duration-300
                        "
                        href={`mailto:${PERSONALINFO.email}`}
                    >
                        {PERSONALINFO.email}
                    </a>
                    <a 
                        className="
                            mt-1
                            text-base
                            sm:text-2xl
                            font-normal
                            tracking-widest

                            hover:text-footerCTA-text-primary
                            transition-colors 
                            duration-300
                        "
                        href={`tel:${PERSONALINFO.phone}`}
                    >
                        {PERSONALINFO.phone}
                    </a>
                </div>

                <div
                    className="
                        max-md:hidden
                        text-3xl
                        mt-7
                    "
                >

                    <a 
                        className="
                            font-normal
                            tracking-widest
                            mt-1

                            hover:text-footerCTA-text-primary
                            transition-colors 
                            duration-300
                        "
                        href={`mailto:${PERSONALINFO.email}`}
                    >
                        {PERSONALINFO.email}
                    </a>
                    <span className="mx-7">|</span>
                    <a 
                        className="
                            mt-1
                            font-normal
                            tracking-widest

                            hover:text-footerCTA-text-primary
                            transition-colors 
                            duration-300
                        "
                        href={`tel:${PERSONALINFO.phone}`}
                    >
                        {PERSONALINFO.phone}
                    </a>
                </div>


            </div> 
        
        </>
    );

}